<template>
    <card>
        <div class="row">

            <div class="col-12 col-md-4">
                <selector @input="setSeason" v-model="season" :title="`Выберите учбеный сезон`" :prefix="'season'"
                    :modal="`season`" :params="{}" :selectKey="`title`" />
            </div>

            <div class="col-12 col-md-4">
                <selector v-if="season" v-model="group" :title="`Выберите класс`" :prefix="'group'" :modal="`group`"
                    :params="{}" :selectKey="`title`" @input="setGroup" />
            </div>

            <div v-if="season && group && season.parts && season.parts.length" class="col-12 col-md-4">
                <label>Выберите четверть</label>
                <select @change="setPart" class="form-control" v-model="part">
                    <option v-for="(p,k) in season.parts" :value="p.id" :key="k">
                        {{p.position}} : {{p.from_at | dateFormat}} - {{p.till_at | dateFormat}}
                    </option>
                </select>
            </div>

        </div>

        <div v-if="part">
            <group-stat  :clients="clients" :group="group" :part="part" :disciplines="disciplines">
            </group-stat>
        </div>
    </card>
</template>

<script>
import GroupStat from '@/components/Progress/GroupStat/index'
// import { dateFormat } from '@/plugins/filtersTemplate';

export default {
    components: {
        GroupStat,
    },
    methods: {
        async setSeason() {
            this.clients = [];
            this.disciplines = [];
            this.part = null;
            this.group = null;
        },
        async setGroup(val) {
            this.clients = [];
            this.disciplines = [];
            this.part = null;
        },
        async setPart(val) {
            this.disciplines = [];
            this.clients = [];
            this.getStat();
        },
        async getStat() {
            this.$loading(true);
            try {
                let result = await this.$http.get(`business/progress/stat/groups/${this.group.id}/parts/${this.part}`);
                if (result && result.data) {
                    let data = result.data;
                    this.disciplines = data.disciplines;
                    this.clients = data.clients;
                  
                }
            } catch (error) {

            }
            this.$loading(false);
        }
    },
    data() {
        return {
            clients: [],
            disciplines: [],
            season: null,
            part: null,
            group: null,
        };
    },

};
</script>